import React from 'react'
import { useTranslation } from 'react-i18next'

import { Stepper } from 'components/Stepper'

import { StyledSectionedProgressBar as S } from './SectionedProgressBar.styles'
import { useSectionedProgress } from './hooks/useSectionedProgress'

const FINISH_CHECKPOINT = { id: 'finish', isReached: false }

export const SectionedProgressBar: React.FC = () => {
  const { t } = useTranslation()
  const { currentSectionTitleKey, sections } = useSectionedProgress()

  const checkpoints = [
    ...sections.map(({ titleKey, progress }) => ({
      id: titleKey,
      isReached: progress > 0,
      progressToNext: progress,
    })),
    FINISH_CHECKPOINT,
  ]

  return (
    <S.Wrapper>
      <S.Title>{t(currentSectionTitleKey)}</S.Title>
      <Stepper checkpoints={checkpoints} />
    </S.Wrapper>
  )
}
